import { useState } from 'react';
import { Tooltip } from 'antd';
import { UpgradeModal } from 'src/modules/ambient_solo/components/Payments/UpgradeModal';
import { ProIcon } from 'src/icons/Pro.icon';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';
export const UpgradeTooltip = ({ children, className }) => {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const { user } = useAuth();

  const handleUpgrade = () => {
    analytics.track('Clicked Upgrade Inside Tooltip', {
      email: user?.email,
    });
    setShowUpgradeModal(true);
  };

  return (
    <>
      <Tooltip
        title={
          <div className="p-4 rounded-lg">
            <p className="mb-3">Upgrade to access this feature</p>
            <button
              className="text-white bg-gradient-to-br from-pink-500 to-blue-700 bg-origin-border bg-clip-padding flex items-center p-2 rounded-xl hover:shadow-xl font-medium px-4 w-full justify-center gap-2"
              type="button"
              onClick={handleUpgrade}
            >
              <ProIcon fill="#fff" forceFlashIcon={true} />
              Upgrade
            </button>
          </div>
        }
        placement="bottomLeft"
        overlayStyle={{ maxWidth: '300px' }}
      >
        <div className={['inline-block', className].filter(Boolean).join(' ')}>
          {children}
        </div>
      </Tooltip>
      <UpgradeModal
        isVisible={showUpgradeModal}
        setIsVisible={setShowUpgradeModal}
      />
    </>
  );
};
